module.exports = __webpack_public_path__ + "img/empreendimento-logo-26.4c4fcc67.png";